"use client";

import Page from "@client/routes/global/error";

export default Page;
